import { getSeatAvailabilityForShowtimeErrorV1 } from './errors/seat-availability-for-showtime-error';
import { getSeatLayoutForShowtimeErrorV1 } from './errors/seat-layout-for-showtime-error';
import { seatingApiRoutes as routes } from './routes';
export function getSeatingApiV1(httpClient) {
    return {
        availability: {
            getForShowtime: (showtimeId, query) => httpClient
                .get(routes.availability.getForShowtime(showtimeId), { queryParams: query })
                .catch(async (e) => {
                throw await getSeatAvailabilityForShowtimeErrorV1(e);
            }),
            getForOrder: (orderId, showtimeId) => httpClient.get(routes.availability.getForOrder(orderId, showtimeId)).catch(async (e) => {
                throw await getSeatAvailabilityForShowtimeErrorV1(e);
            })
        },
        masterData: {
            seatLayout: {
                getById: seatLayoutId => httpClient.get(routes.masterData.seatLayout.getById(seatLayoutId)),
                getForShowtime: showtimeId => httpClient.get(routes.masterData.seatLayout.getForShowtime(showtimeId)).catch(async (e) => {
                    throw await getSeatLayoutForShowtimeErrorV1(e);
                })
            }
        }
    };
}
//# sourceMappingURL=get-seating-api.js.map